import React, { useRef, useState, useEffect } from 'react';
import { useStyles } from './SubMenuList.styles';
import clsx from 'clsx';
import {
  Link as RouterLink,
  LinkProps as RouterLinkProps,
  useLocation,
} from 'react-router-dom';
import {
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@mui/material';

const CustomMenuItem = (props: any) => {
  const { classes } = useStyles();
  const textElement = useRef<any>();
  const { obj } = props;
  const newLocation = useLocation();
  const [isActive, setIsActive] = useState(obj.to === newLocation.pathname || newLocation.pathname.includes(obj.to));
  const location = useLocation();

  useEffect(() => {
    setIsActive(obj.to === location.pathname || location.pathname.includes(obj.to));
  }, [location]);

  return (
      <>
      {obj.isSubHeader && (
      <ListItem className={clsx(classes.subHeaderNested)}>
          <ListItemText 
          className={classes.subHeader} 
          primary={<b style={{fontSize:'15px'}}>{obj.text}</b>} />
      </ListItem>
      )}

      {!obj.isSubHeader && (
      <ListItem
        button
        selected={isActive ? true : false}
        component={React.forwardRef<any, Omit<RouterLinkProps, 'to'>>(
          (itemProps, ref) => (
            <RouterLink to={obj.to} ref={ref} {...itemProps}  onClick={()=>{
              props.onClick()
            }}/>
          ),
        )}
        className={clsx(
          classes.nested,
          isActive ? classes.listItemActive : classes.listItemInactive,
        )}
        classes={{
          root: classes.listItemRoot,
          selected: isActive ? classes.selected : '',
        }}
      >
        <ListItemIcon
          className={classes.icon}
          classes={{
            root: isActive ? classes.iconRoot : '',
          }}
        >
          {obj.icon}
        </ListItemIcon>
        <ListItemText
          primary={obj.text}
          primaryTypographyProps={{
            className: classes.subMenuText,
            ref: textElement,
          }}
        />
      </ListItem>
      )}
    </>
  );
};

export default CustomMenuItem;
